/**
 * Utilitaires d'export des tableaux (Excel via xlsx, PDF via jspdf + autotable).
 * Utilisés par le composant générique DataTable pour tous les tableaux
 * (Findings, Actions, CCV, PCED...).
 */
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function exportToExcel(data, columns, filename = "export") {
  const rows = data.map((row) =>
    columns.reduce((acc, col) => {
      acc[col.label] = row[col.key];
      return acc;
    }, {})
  );
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Données");
  XLSX.writeFile(workbook, `${filename}.xlsx`);
}

export function exportToPDF(data, columns, filename = "export", title = "Export") {
  const doc = new jsPDF();
  doc.setFontSize(14);
  doc.setTextColor(11, 83, 148);
  doc.text(title, 14, 15);
  autoTable(doc, {
    startY: 22,
    head: [columns.map((c) => c.label)],
    body: data.map((row) => columns.map((c) => String(row[c.key] ?? ""))),
    styles: { fontSize: 8 },
    headStyles: { fillColor: [11, 83, 148] },
  });
  doc.save(`${filename}.pdf`);
}
